import {JwtHttpClientService} from "@fedeltapointofsale/data-client";
import {CubeDefinitionData} from "./cube-definition.data";
import {Injectable} from "@angular/core";
import {ChartQueryRequestData} from "./chart-query-request.data";
import {FlatOlapResultsData} from "./flat-olap-results.data";
import {PivotQueryRequestData} from "./pivot-query-request.data";
import {OlapPivotResultsData} from "./olap-pivot-results.data";
import {RestrictionsRequestData} from "./restrictions-request.data";
import {RestrictionsResponseData} from "./restrictions-response.data";
import {firstValueFrom, map, Observable} from "rxjs";
import {ServerStatusData} from "./server-status/server-status.data";
import {HttpResponse} from "@angular/common/http";

@Injectable()
export class BIService {

    constructor(private http: JwtHttpClientService) {
    }

    public getDefaultCube(): string {
        return "ProductSales";
    }

    public getServerStatus(): Promise<ServerStatusData> {
        return firstValueFrom(this.http.get("/biserver/server-status").pipe(
            map((response: HttpResponse<Object>) => <ServerStatusData>(response.body || {}))
        ));
    }

    public getCube(cubeName: string): Promise<CubeDefinitionData> {
        return firstValueFrom(this.http.get("/biserver/cube?name=" + cubeName).pipe(
            map((response: HttpResponse<Object>) => <CubeDefinitionData>(response.body || {}))
        ));
    }

    public getMemberMap(cubeName: string, members: string[]): Promise<{ [key: string]: string }> {
        const query: any = {
            cubeName: cubeName,
            members: members
        };
        return firstValueFrom(this.http.post("/biserver/membermap", query).pipe(
            map((response: HttpResponse<Object>) => (response.body || {})["memberMap"])
        ));
    }

    public queryChart(request: ChartQueryRequestData): Observable<FlatOlapResultsData> {
        return this.http.post("/biserver/chart", request).pipe(
            map((response: HttpResponse<Object>) => <FlatOlapResultsData>(response.body || {}))
        );
    }

    public queryPivot(request: PivotQueryRequestData): Observable<OlapPivotResultsData> {
        return this.http.post("/biserver/pivot", request).pipe(
            map((response: HttpResponse<Object>) => <OlapPivotResultsData>(response.body || {}))
        );
    }

    public queryPivotExcel(request: PivotQueryRequestData): Promise<Blob> {
        return firstValueFrom(this.http.post("/biserver/pivotExcel", request, undefined, undefined, "blob").pipe(
            map((response: HttpResponse<Blob>) => response.body)
        ));
    }

    public getRestrictions(request: RestrictionsRequestData): Promise<RestrictionsResponseData> {
        return firstValueFrom(this.http.post("/biserver/restrictions", request).pipe(
            map((response: HttpResponse<Object>) => <RestrictionsResponseData>(response.body || {}))
        ));
    }

    public cancelQuery(queryId: string): void {
        this.http.get("/biserver/cancelQuery?queryId=" + queryId).subscribe(() => {
        });
    }
}
